<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Ingresos</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter  v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Periodo:</label>
        <select v-if="$page.props.auth.user.rol !='Exportador'" v-model="form.trashed" class="mt-1 w-full form-select">
          <option value="siempre">Todos</option>
          <option value="hoy">Hoy</option>
        </select>       
      </search-filter>
       <inertia-link class="btn-indigo" :href="route('filtros.diarios')">
        <span>Filtro</span>
        <span class="hidden md:inline"> General</span>
      </inertia-link>
      <inertia-link v-if="$page.props.auth.user.rol =='Admin' || $page.props.auth.user.rol=='Recepcion'" class="btn-indigo" :href="route('diarios.create')">
        <span>Crear</span>
        <span class="hidden md:inline">Ingreso</span>
      </inertia-link>
    </div>
    <h3>Total Gavetas General <b>{{ gavetas  }}</b> y Total Kilos netos <b>{{ peso }}</b> kg</h3>
    <br>
    <br>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap table-bordered">
        <tr class="border-t text-center font-bold">
           <th class="border-r px-6 pt-6 pb-4">Nº Lote  </th>
           <th class="border-r px-6 pt-6 pb-4">Fecha LLegada</th>
          <th class="border-r px-6 pt-6 pb-4">Exportador</th>
          <th class="border-r px-6 pt-6 pb-4">Hacienda</th>
          <th class="border-r px-6 pt-6 pb-4">Total Gavetas</th>
           <th class="border-r px-6 pt-6 pb-4">Total Peso Neto kg</th>
           <th class="border-r px-6 pt-6 pb-4">Peso Prom. Gaveta</th>
          <th class="border-r px-6 pt-6 pb-4">Descarga Inicio</th>
          <th class="border-r px-6 pt-6 pb-4">Descarga Fin</th>
          <th class="border-r px-6 pt-6 pb-4">Tiempo de Descarga</th>
          <th class="border-r px-6 pt-6 pb-4">Tiempo de Espera</th>


        </tr>
        <tr v-for="diario in diarios.data" :key="diario.id" class="border-t hover:bg-gray-100 focus-within:bg-gray-100">
           <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
                {{ diario.lote }}
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
                {{ diario.fecha_llegada }}
            </inertia-link>
          </td>
         <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
              <div v-if="diario.contact">
                {{ diario.contact }}
              </div>
            </inertia-link>
          </td>
           <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
                {{ diario.origen }}     
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
              {{ diario.total }}
            </inertia-link>
          </td>
           <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
              {{ diario.peso }} kg
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
              {{ diario.promedio }} kg
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('diarios.edit', diario.id)">
              {{ diario.fecha }}
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('diarios.edit', diario.id)">
              {{ diario.fecha_fin }}
              <icon v-if="diario.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
              {{ diario.tiempo }} h:m:s
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
              {{ diario.espera }} h:m:s
            </inertia-link>
          </td>
          <td class="border-r w-px">
            <inertia-link class="px-4 flex items-center" :href="route('diarios.edit', diario.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="diarios.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No se encontraron ingresos</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="diarios.links" />
<br>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'Ingreso' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    diarios: Object,
    gavetas: Object,
    peso: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        tipo: 'Ingreso',
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('diarios'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
